import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { RegistrationsEffects } from 'app/state/registrations/registrations.effects';
import { registrationsFeature } from 'app/state/registrations/registrations.reducer';

@NgModule({
    declarations: [],
    imports: [StoreModule.forFeature(registrationsFeature), EffectsModule.forFeature([RegistrationsEffects])],
})
export class RegistrationStateModule {}
